
import { defineComponent, ref, nextTick, onMounted } from "vue"
import { spatialOmicsApi } from "@/request";
import GeneExpressionComparePlot from "@/components/GeneExpressionComparePlot.vue";

export default defineComponent({
  components: {
    GeneExpressionComparePlot
  },
  setup() {
    let geneFeatureList = ref([])
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    let geneFeatureAllList = []
    let selectedGeneFeature = ref('')
    let selectedGeneFeature2 = ref('')
    let markerSize = ref(2)
    let markerSizeList = ref([1,2,3,4,5,6,7,8,9,10])
    let useLog = ref(false)
    let logable = ref(true)
    // 
    let colorSetMin = ref(0)
    let colorSetMax = ref(0)
    let reverseColor = ref(false)
    let expressionMin = ref(0)
    let expressionMax = ref(0)
    let expressionMedian = 0
    let expressionSetMin = ref(0)
    let expressionSetMax = ref(0)

    let useMedian = ref(false)
    let reverseSelect = ref(false)
    let dataId = -1
    let expressionPlot: any = ref(null)

    /**
     * 获取当前的data id
     */
    const getDataId = () => {
      return dataId
    }

    /**
     * 散点图点大小改变的回调函数
     */
    const markerSizeChangeCallback = () => {
      console.log(markerSize)
      expressionPlot.value.changeMarkerSize(markerSize.value)
    }

    /**
     * 设置数据
     * @param data data数据
     */
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const setData = (data) => {
      dataId = data.id
      let geneList = data['feature_list']['gene']
      selectedGeneFeature.value = geneList[0]
      selectedGeneFeature2.value = geneList[0]
      geneFeatureList.value = geneList.map((value: string) => {
        return {
          value: value,
          label: value,
        }
      })
      geneFeatureAllList = geneList.map((value: string) => {
        return {
          value: value,
          label: value,
        }
      })
    }

    /**
     * 基因选项的filter函数
     * @param query 查询字符串
     */
    const geneFeatureFilter = (query: string) => {
      console.log(query)
      if (query !== '') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        geneFeatureList.value = geneFeatureAllList.filter((item: any) => {
          return item.label.toLowerCase().includes(query.toLowerCase())
        })
      } else {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        geneFeatureList.value = geneFeatureAllList
      }
    }

    /**
     * 根据选择的基因获取当前基因的expression相关数据，并更新相关的图
     */
    const geneFeatureChangeCallBack = () => {
      spatialOmicsApi.getGeneExpression({
        'data_id': dataId,
        'gene': selectedGeneFeature.value,
      }).then((res1) => {
          spatialOmicsApi.getGeneExpression({
            'data_id': dataId,
            'gene': selectedGeneFeature2.value,
          }).then((res2) => {
          console.log("res1", res1.data['gene_plot'])
          console.log("res2", res2.data['gene_plot'])
          let data1 = res1.data['gene_plot']
          let data2 = res2.data['gene_plot']
          let data = JSON.parse(JSON.stringify(data1))
          let values = []
          for(let i=0;i<data.length;i++){
            if(data1[i][2] === "value" || data2[i][2] === "value") continue;
            data[i][2] = data1[i][2] - data2[i][2]
            values.push(data[i][2])
          }

          logable.value = res1.data['logable']
          expressionMin.value = res1.data['value_min']
          expressionMax.value = res1.data['value_max']
          expressionMedian = res1.data['value_median']
          expressionSetMin.value = expressionMin.value
          expressionSetMax.value = expressionMax.value
          colorSetMin.value = expressionMin.value
          colorSetMax.value = expressionMax.value
          console.log("geneFeatureChangeCallBack", expressionPlot)
          expressionPlot.value.setPlotData(res1.data['gene_plot'])
          expressionPlot.value.setVisualMinMax(colorSetMin.value, colorSetMax.value)

          logable.value = res2.data['logable']
          expressionMin.value = res2.data['value_min']
          expressionMax.value = res2.data['value_max']
          expressionMedian = res2.data['value_median']
          expressionSetMin.value = expressionMin.value
          expressionSetMax.value = expressionMax.value
          colorSetMin.value = expressionMin.value
          colorSetMax.value = expressionMax.value
          console.log("geneFeatureChangeCallBack", expressionPlot)
          expressionPlot.value.setPlotData2(res2.data['gene_plot'])
          expressionPlot.value.setVisualMinMax2(colorSetMin.value, colorSetMax.value)

          values.sort()
          logable.value = res1.data['logable']
          expressionMin.value = values[0]
          expressionMax.value = values[values.length - 1]
          expressionMedian = values[values.length / 2]
          expressionSetMin.value = expressionMin.value
          expressionSetMax.value = expressionMax.value
          colorSetMin.value = expressionMin.value
          colorSetMax.value = expressionMax.value
          console.log("geneFeatureChangeCallBack", expressionPlot)
          expressionPlot.value.setPlotDataSub(data)
          console.log(values[0], values[values.length - 1], values[values.length / 2])
          expressionPlot.value.setVisualMinMaxSub(colorSetMin.value, colorSetMax.value)
        })
      })
    }

    /**
     * log switch值改变的回调函数，用于设置基因强度值是否log
     */
    const logChangeCallBack = () => {
      console.log(useLog.value)
      if (useLog.value) {
        expressionSetMin.value = Math.log(1 + expressionSetMin.value)
        expressionSetMax.value = Math.log(1 + expressionSetMax.value)
        colorSetMin.value = Math.log(1 + colorSetMin.value)
        colorSetMax.value = Math.log(1 + colorSetMax.value)
        expressionMedian = Math.log(1 + expressionMedian)
      } else {
        expressionSetMin.value = Math.exp(expressionSetMin.value) - 1
        expressionSetMax.value = Math.exp(expressionSetMax.value) - 1
        colorSetMin.value = Math.exp(colorSetMin.value) - 1
        colorSetMax.value = Math.exp(colorSetMax.value) - 1
        expressionMedian = Math.exp(expressionMedian) - 1
      }
      expressionPlot.value.setLog(useLog.value)
    }

    /**
     * 设置是否反转散点图的颜色
     */
    const reverseColorChangeCallBack = () => {
      console.log(useLog.value)
      expressionPlot.value.setReverseColor(reverseColor.value)
    }

    /**
     * 设置散点图基因强度visual map的最小最大值
     */
    const setColorMinMax = () => {
      expressionPlot.value.setVisualMinMax(colorSetMin.value, colorSetMax.value)
    }

    /**
     * 设置散点图基因强度选择的最小最大值
     */
    const setSelectMinMax = () => {
      expressionPlot.value.setSelectMinMax(expressionSetMin.value, expressionSetMax.value)
    }

    /**
     * 将基因强度选择的最小值设为最小值，最大值设为中值
     */
    const setMedian = () => {
      if (useMedian.value) {
        expressionSetMin.value = expressionMin.value
        expressionSetMax.value = expressionMedian
      } else {
        expressionSetMin.value = expressionMin.value
        expressionSetMax.value = expressionMax.value
      }
    }

    /**
     * 设置是否反转基因强度的选择区间
     */
    const reverseSelectChangeCallBack = () => {
      expressionPlot.value.setSelectReverse(reverseSelect.value)
    }

    return {
      geneFeatureList,
      selectedGeneFeature,
      selectedGeneFeature2,
      markerSize,
      markerSizeList,
      useLog,
      logable,
      expressionMin,
      expressionMax,
      colorSetMin,
      colorSetMax,
      expressionSetMin,
      expressionSetMax,
      reverseColor,
      reverseSelect,
      useMedian,
      expressionPlot,
      getDataId,
      setData,
      markerSizeChangeCallback,
      geneFeatureChangeCallBack,
      logChangeCallBack,
      setColorMinMax,
      setSelectMinMax,
      reverseColorChangeCallBack,
      reverseSelectChangeCallBack,
      setMedian,
      geneFeatureFilter,
    }
  }
})

